<template>
  <div class="space-3"></div>
  <div class="global-container">
    <h1 class="mb-lg">Referenzen</h1>
    <div class="referenzen__wrapper">
      <div class="col">
        <div class="group-A">
          <p class="group-label">A</p>
          <div class="customers">
            <p class="customer">Adidas</p>
            <p class="customer">AK Oberösterreich</p>
            <p class="customer">Alpenland</p>
            <p class="customer">Ambient Art</p>
          </div>
        </div>
        <div class="group-B">
          <p class="group-label">B</p>
          <div class="customers">
            <p class="customer">Bacardi</p>
            <p class="customer">Barracuda Music</p>
            <p class="customer">BMW</p>
            <p class="customer">Brau Union</p>
          </div>
        </div>
        <div class="group-C">
          <p class="group-label">C</p>
          <div class="customers">
            <p class="customer">Chanel</p>
            <p class="customer">Coca Cola</p>
          </div>
        </div>
        <div class="group-D">
          <p class="group-label">D</p>
          <div class="customers">
            <p class="customer">Dior</p>
          </div>
        </div>
        <div class="group-F">
          <p class="group-label">F</p>
          <div class="customers">
            <p class="customer">Fanta</p>
            <p class="customer">Fiat</p>
            <p class="customer">FIFA</p>
            <p class="customer">Fußball WM Deutschland</p>
          </div>
        </div>
        <div class="group-G">
          <p class="group-label">G</p>
          <div class="customers">
            <p class="customer">Granit Bau</p>
            <p class="customer">Green Peace</p>
          </div>
        </div>
        <div class="group-H">
          <p class="group-label">H</p>
          <div class="customers">
            <p class="customer">H&M</p>
            <p class="customer">Hahnenkamm Kitzbühel</p>
            <p class="customer">Hornbach</p>
          </div>
        </div>
        <div class="group-I">
          <p class="group-label">I</p>
          <div class="customers">
            <p class="customer">Italien Tourismus</p>
          </div>
        </div>
        <div class="group-K">
          <p class="group-label">K</p>
          <div class="customers">
            <p class="customer">Königshaus Holland</p>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="group-L">
          <p class="group-label">L</p>
          <div class="customers">
            <p class="customer">Live Nation</p>
          </div>
        </div>

        <div class="group-M">
          <p class="group-label">M</p>
          <div class="customers">
            <p class="customer">Milka</p>
            <p class="customer">Möbel Lutz</p>
            <p class="customer">Moon City Salzburg</p>
          </div>
        </div>

        <div class="group-N">
          <p class="group-label">N</p>
          <div class="customers">
            <p class="customer">New Design University</p>
          </div>
        </div>

        <div class="group-O">
          <p class="group-label">O</p>
          <div class="customers">
            <p class="customer">ÖMV</p>
            <p class="customer">ÖSV</p>
          </div>
        </div>

        <div class="group-P">
          <p class="group-label">P</p>
          <div class="customers">
            <p class="customer">Podersdorf</p>
            <p class="customer">Poolbar Feldkirch</p>
            <p class="customer">PSV Eindhoven</p>
          </div>
        </div>

        <div class="group-Q">
          <p class="group-label">Q</p>
          <div class="customers">
            <p class="customer">Quooker</p>
          </div>
        </div>

        <div class="group-R">
          <p class="group-label">R</p>
          <div class="customers">
            <p class="customer">Raiffeisen Bank</p>
            <p class="customer">Römerquelle</p>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="group-S">
          <p class="group-label">S</p>
          <div class="customers">
            <p class="customer">Sparkasse</p>
            <p class="customer">Special Olympics</p>
            <p class="customer">Stadt Salzburg</p>
            <p class="customer">Stadt St. Pölten</p>
            <p class="customer">Stadt Wien</p>
            <p class="customer">Strabag</p>
            <p class="customer">Szene Open Air Lustenau</p>
          </div>
        </div>

        <div class="group-T">
          <p class="group-label">T</p>
          <div class="customers">
            <p class="customer">TAG Heuer</p>
          </div>
        </div>

        <div class="group-U">
          <p class="group-label">U</p>
          <div class="customers">
            <p class="customer">UEFA</p>
            <p class="customer">Uni Seeburg</p>
          </div>
        </div>

        <div class="group-V">
          <p class="group-label">V</p>
          <div class="customers">
            <p class="customer">Van Gogh Museum Amsterdam</p>
            <p class="customer">Volkswagen</p>
            <p class="customer">Vöslauer</p>
          </div>
        </div>

        <div class="group-Z">
          <p class="group-label">Z</p>
          <div class="customers">
            <p class="customer">Zalando</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup></script>

<style scoped lang="scss">
.referenzen__wrapper {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  @media (min-width: 500px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
  .customers {
    padding-left: map-get($spaces, "xs");
    margin-bottom: map-get($spaces, "md");
    p {
      font-size: 1rem;
      color: $text--col;
    }
  }
}
</style>
